import React, { Component } from 'react';
import { connect } from 'react-redux';

class HowMembershipWorksNegOp extends Component {
    render() {
        let titlesType, handpicked;
        let hardcovers = 'Hardcovers',
            percentage = '25%',
            publisherPrices = "Publishers' Edition prices",
            best = "best",
            books = "books",
            booksOrMovies = "books",
            featured = "Featured",
            featuredSelections = "Featured Selections",
            extraSave = "—no other purchase necessary";

        switch(this.props.tla){
            case "TGC":
                titlesType = "cooking";
                handpicked = "cookbooks";
                break;
            case "MIL":
                titlesType = "military";
                handpicked = "military titles";
                break;
            case "CRF":
                titlesType = "crafting";
                handpicked = "crafting titles";
                break;
            case "LSC":
                titlesType = "";
                handpicked = "titles";
                break;
            case "SPT":
                titlesType = "mind/body/spirit";
                handpicked = "books for transforming your life";
                break;
            case "DLP":
                titlesType = "large print";
                handpicked = "easy-to-read bestsellers, romance novels, mysteries, biographies, and more";
                break;
            case "DVD":
                hardcovers = "DVDs", percentage = "60%", publisherPrices = "regular Club prices",
                best="hottest", books = "DVDs", featured = "Director's", handpicked= "movies",
                booksOrMovies = "movies", titlesType = "", featuredSelections ="Director's Selection",
                extraSave = "";
                break;
            default:
                titlesType = "";
                handpicked = "titles";
                break;
        }

        return(
            <div className="how-membership-works">
            	  <div className="banner" />
                <div className="benefits">
                    <h4 className="alt primary-color">Benefits of Your Membership</h4>
                    <div className="">
                        <div className="half-col check-list">
                            <ul>
                                <li>{hardcovers} at up to <strong>{percentage}</strong> off {publisherPrices}</li>
                                <li>Curated selection of today's {best} {titlesType} titles</li>
                                <li>Always free shipping on orders of 3 or more {books}*</li>
                                <li>No obligation, and you can cancel anytime</li>
                            </ul>
                        </div>
                        <div className="half-col books">
                        </div>
                    </div>
                </div>

                <div className="hiw neg-op">
                    <h4 className="alt primary-color">How Your Membership Works</h4>
                    <div className="col-30 join">
	                    <h3 id="join">Join now and start saving</h3>
	                    <p>Get two {books} for ${this.props.second_book} each with your new membership. </p>
	                  </div>
	                  <div className="col-30 featured">
	                    <h3 id="featured">{featured} Selections</h3>
	                    <p>Every few weeks, we'll reveal our new {featuredSelections}—a choice of today's top {handpicked} hand-picked by your editor.</p>
	                  </div>
                    <div className="col-30">
	                    <h3 id="save">Save on every title</h3>
	                    <p>Get savings of up to {percentage} off {publisherPrices}{extraSave}.</p>
                   	</div>
                   	<div className="col-30">
	                   	<h3 id="shipping">Free shipping</h3>
						<p>With every order of 3 or more {books}, the shipping's on us. Members are eligible for free shipping when the total purchase price is $35 or more.</p>
					</div>
					<div className="col-30 choose">
						<h3 id="choose">Choose only the {books} you want</h3>
						<p>You're free to take any {featured} Selection—or skip it altogether and save on only the {booksOrMovies} you want.</p>
					</div>
					<div className="col-30">
						<h3 id="cancel">Cancel anytime</h3>
						<p> There is no obligation to buy and you can cancel your membership anytime online or by calling {this.props.member_services_phone}.</p>
                		</div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state){
    return {
      'name': state.store.name,
      'type': state.store.type,
      'second_book': state.store.second_book,
      'one_credit': state.store.one_credit,
      'member_services_phone': state.store.member_services_phone,
      'tla': state.store.tla
    };
}

export default connect(mapStateToProps)(HowMembershipWorksNegOp);



// WEBPACK FOOTER //
// ./src/components/HowMembershipWorksNegOp.jsx